"use client";
import { ArrowBlogIcon } from "@/icons";
import Image from "next/image";
import Masonry from "react-masonry-css";

const breakpointColumnsObj = {
  default: 3,
  1100: 2, // Reduz para 2 colunas em telas menores que 1100px
  768: 1, // Para telas menores que 768px (mobile), deve ficar com 1 coluna
};

const MansoryLayout = () => {
  return (
    <>
      <div className="mx-auto max-w-[1216px] px-4 py-28">
        <Masonry
          key={typeof window !== "undefined" ? window.innerWidth : "default"}
          breakpointCols={breakpointColumnsObj}
          className="my-masonry-grid"
          columnClassName="my-masonry-grid_column"
        >
          {/* Item 1 - Click com você */}
          <GalleryItem
            href="/galeria"
            imageSrc="/image/camisa.webp"
            title="Click com você"
            description="Além de cuidados médicos, oferecemos brindes exclusivos para nossos pacientes!"
          />

          {/* Item 2 - Click nas ruas */}
          <GalleryItem
            href="/galeria"
            imageSrc="/image/galeria/nas-ruas/7.webp"
            title="Click nas ruas"
            description="Já viu nossos outdoors pelo RJ? Clique e descubra onde estamos espalhando nossa mensagem pela cidade."
          />

          {/* Item 3 - Click em movimento */}
          <GalleryItem
            href="/galeria"
            imageSrc="/image/galeria/nas-rodas/4.webp"
            title="Click em movimento"
            description="Se você está no RJ, certamente já cruzou com um dos carros ou ônibus da Click Cannabis."
          />
        </Masonry>
      </div>

      {/* CSS para Masonry */}
      <style jsx global>{`
        .my-masonry-grid {
          display: flex;
          margin-left: -30px;
          width: auto;
        }
        .my-masonry-grid_column {
          padding-left: 30px;
          background-clip: padding-box;
        }
        .my-masonry-grid_column > div {
          margin-bottom: 80px;
        }
      `}</style>
    </>
  );
};

function GalleryItem({
  href,
  imageSrc,
  title,
  description,
}: {
  href: string;
  imageSrc: string;
  title: string;
  description: string;
}) {
  return (
    <a href={href} className="block mb-8 cursor-pointer">
      {/* Imagem com Aspect Ratio corrigido */}
      <div className="relative w-full h-64 overflow-hidden rounded-xl">
        <Image src={imageSrc} alt={title} fill className="object-cover" />
      </div>
      {/* Texto e Ícone */}
      <div className="flex flex-row items-start gap-4 pt-4">
        <div className="flex flex-col gap-2">
          <h3 className="text-3xl">{title}</h3>
          <p className="text-sm text-gray-500">{description}</p>
        </div>
        <div className="rounded-full bg-gray-100 p-4">
          <ArrowBlogIcon />
        </div>
      </div>
    </a>
  );
}

export default MansoryLayout;
